// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicSpotGetMarketSymbols (params?: {}): Promise<Dict>;
    publicSpotGetKline (params?: {}): Promise<Dict>;
    publicSpotGetMarginCurrencies (params?: {}): Promise<Dict>;
    publicSpotGetMarginSymbols (params?: {}): Promise<Dict>;
    publicSpotGetMarkets (params?: {}): Promise<Dict>;
    publicSpotGetOrderBook (params?: {}): Promise<Dict>;
    publicSpotGetPing (params?: {}): Promise<Dict>;
    publicSpotGetSpotSymbols (params?: {}): Promise<Dict>;
    publicSpotGetTime (params?: {}): Promise<Dict>;
    publicSpotGetTrades (params?: {}): Promise<Dict>;
    publicSpotGetTradesSymbols (params?: {}): Promise<Dict>;
    publicSpotGetTicker (params?: {}): Promise<Dict>;
    publicSpotGetCurrencies (params?: {}): Promise<Dict>;
    publicSwapGetPublicApiWeight (params?: {}): Promise<Dict>;
    publicSwapGetPublicCandles (params?: {}): Promise<Dict>;
    publicSwapGetPublicCandlesHistory (params?: {}): Promise<Dict>;
    publicSwapGetPublicDepth (params?: {}): Promise<Dict>;
    publicSwapGetPublicFundingRate (params?: {}): Promise<Dict>;
    publicSwapGetPublicFundingRateHistory (params?: {}): Promise<Dict>;
    publicSwapGetPublicInstrument (params?: {}): Promise<Dict>;
    publicSwapGetPublicInstruments (params?: {}): Promise<Dict>;
    publicSwapGetPublicTicker (params?: {}): Promise<Dict>;
    publicSwapGetPublicTickers (params?: {}): Promise<Dict>;
    publicSwapGetPublicTime (params?: {}): Promise<Dict>;
    publicSwapGetPublicTrades (params?: {}): Promise<Dict>;
    privateSpotGetMarketFinancelog (params?: {}): Promise<Dict>;
    privateSpotGetMarketMytrades (params?: {}): Promise<Dict>;
    privateSpotGetMarketOrder (params?: {}): Promise<Dict>;
    privateSpotGetMarketOrderDetail (params?: {}): Promise<Dict>;
    privateSpotGetMarketOrderCurrent (params?: {}): Promise<Dict>;
    privateSpotGetMarketOrderHistory (params?: {}): Promise<Dict>;
    privateSpotGetMarginAssets (params?: {}): Promise<Dict>;
    privateSpotGetMarginFinancelog (params?: {}): Promise<Dict>;
    privateSpotGetMarginMytrades (params?: {}): Promise<Dict>;
    privateSpotGetMarginOrder (params?: {}): Promise<Dict>;
    privateSpotGetMarginOrderCurrent (params?: {}): Promise<Dict>;
    privateSpotGetMarginOrderHistory (params?: {}): Promise<Dict>;
    privateSpotGetMarginPositions (params?: {}): Promise<Dict>;
    privateSpotGetOtcFinancelog (params?: {}): Promise<Dict>;
    privateSpotGetSpotAssets (params?: {}): Promise<Dict>;
    privateSpotGetSpotFinancelog (params?: {}): Promise<Dict>;
    privateSpotGetSpotMytrades (params?: {}): Promise<Dict>;
    privateSpotGetSpotOrder (params?: {}): Promise<Dict>;
    privateSpotGetSpotOrderCurrent (params?: {}): Promise<Dict>;
    privateSpotGetSpotOrderHistory (params?: {}): Promise<Dict>;
    privateSpotGetDepositAddress (params?: {}): Promise<Dict>;
    privateSpotGetDepositHistory (params?: {}): Promise<Dict>;
    privateSpotGetWithdrawHistory (params?: {}): Promise<Dict>;
    privateSpotPostMarketOrderCancel (params?: {}): Promise<Dict>;
    privateSpotPostMarketOrderNew (params?: {}): Promise<Dict>;
    privateSpotPostMarketOrderBatchNew (params?: {}): Promise<Dict>;
    privateSpotPostMarginOrderCancel (params?: {}): Promise<Dict>;
    privateSpotPostMarginOrderNew (params?: {}): Promise<Dict>;
    privateSpotPostMarginPositionClose (params?: {}): Promise<Dict>;
    privateSpotPostSpotOrderCancel (params?: {}): Promise<Dict>;
    privateSpotPostSpotOrderNew (params?: {}): Promise<Dict>;
    privateSpotPostTransfer (params?: {}): Promise<Dict>;
    privateSpotPostWithdrawNew (params?: {}): Promise<Dict>;
    privateSpotPostWithdrawCancel (params?: {}): Promise<Dict>;
    privateSwapGetAccountBalance (params?: {}): Promise<Dict>;
    privateSwapGetAccountPositions (params?: {}): Promise<Dict>;
    privateSwapGetAccountFinanceRecord (params?: {}): Promise<Dict>;
    privateSwapGetAccountTradingFeeRate (params?: {}): Promise<Dict>;
    privateSwapGetAccountTransferRecord (params?: {}): Promise<Dict>;
    privateSwapGetAccountFundingFee (params?: {}): Promise<Dict>;
    privateSwapGetTradeHistoryOrders (params?: {}): Promise<Dict>;
    privateSwapGetTradeHistoryTrades (params?: {}): Promise<Dict>;
    privateSwapGetTradeOpenOrders (params?: {}): Promise<Dict>;
    privateSwapGetTradeOrderInfo (params?: {}): Promise<Dict>;
    privateSwapPostAccountTransfer (params?: {}): Promise<Dict>;
    privateSwapPostAccountLeverage (params?: {}): Promise<Dict>;
    privateSwapPostAccountPositionMode (params?: {}): Promise<Dict>;
    privateSwapPostAccountPositionMargin (params?: {}): Promise<Dict>;
    privateSwapPostTradeBatchCancelOrder (params?: {}): Promise<Dict>;
    privateSwapPostTradeBatchOrder (params?: {}): Promise<Dict>;
    privateSwapPostTradeCancelOrder (params?: {}): Promise<Dict>;
    privateSwapPostTradeOrderPlace (params?: {}): Promise<Dict>;
    privateSwapPostFollowSponsorOrder (params?: {}): Promise<Dict>;
    privateSwapPostFollowCloseOrder (params?: {}): Promise<Dict>;
    privateSwapPostFollowCancelOrder (params?: {}): Promise<Dict>;
    privateSwapPostFollowUserCenterCurrent (params?: {}): Promise<Dict>;
    privateSwapPostFollowUserCenterHistory (params?: {}): Promise<Dict>;
    privateSwapPostFollowExpertCurrentOpenOrder (params?: {}): Promise<Dict>;
    privateSwapPostFollowAddAlgo (params?: {}): Promise<Dict>;
    privateSwapPostFollowCancelAlgo (params?: {}): Promise<Dict>;
    privateSwapPostFollowAccountAvailable (params?: {}): Promise<Dict>;
    privateSwapPostFollowPlanTask (params?: {}): Promise<Dict>;
    privateSwapPostFollowInstrumentList (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
